export default __webpack_public_path__ + "static/media/event-editor-group-menu.3ffd3c1a.png";